import { TablePage } from '../../../models/table.model';

export interface TablePageRange {
  /** One-based position of the first row on the page, or 0 when there are no rows. */
  from: number;
  /** One-based position of the last row on the page. */
  to: number;
  pageCount: number;
  isFirst: boolean;
  isLast: boolean;
}

/** Where the page sits among all rows. An empty table still counts as a single page. */
export function tablePageRange({ index, size }: TablePage, totalCount: number): TablePageRange {
  const pageCount = Math.max(1, Math.ceil(totalCount / size));

  return {
    from: totalCount > 0 ? (index * size) + 1 : 0,
    to: Math.min((index + 1) * size, totalCount),
    pageCount,
    isFirst: index <= 0,
    isLast: index >= pageCount - 1,
  };
}
